// extracted by mini-css-extract-plugin
export var dataCell = "_mz-2";
export var dataRow = "_mz-0";
export var headerRow = "_mz-1";